/**
 * Last row options enum for justified gallery block
 *
 * @enum LAST_ROW
 * @type {{NO_JUSTIFY: string, JUSTIFY: string, HIDE: string, LEFT: string, RIGHT: string}}
 */
const LAST_ROW = {
  NO_JUSTIFY: 'nojustify',
  JUSTIFY: 'justify',
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  HIDE: 'hide',
};

export { LAST_ROW };
